const productSubFamily = {
  tab: {
    main: "Sous-famille",
    price: "Prix",
    mainEdit: "Editer",
    configuration: "Configuration",
    configurationEdit: "Editer",
    accounting: "Comptabilité",
    datasheet: "Datasheet",
    technicalData: "Données techniques",
    api: "APIs",
    specificConditionsOfSale: "Conditions particulières de vente"
  },
  new: {
    title: "Nouvelle famille de produit",
    steps: {
      generalData: "Informations Générales",
      price: "Prix",
      datasheet: "Définition datasheet",
      technicalData: "Définition données techniques",
      specificConditionsOfSale: "Conditions particulières de vente"
    }
  },
  search: {
    productFamily: "Famille",
    name: "Nom",
    activeOrder: "Actif en commande",
    activeQuote: "Actif en devis",
    activeTicket: "Actif en ticket",
    rentable: "Louable"
  }
};

export default productSubFamily;
